/**
 * 打刻できる場所と、登録した場所の外では打刻させない設定の、画面の文。
 * 言葉は台帳（SR-1〜）のとおり。ここ1か所にまとめて、画面ごとに言い方が割れないようにする。
 */
export default Object.freeze({
  // 自社設定のスイッチ
  restrictName: '指定エリア外での打刻制限',
  restrictDescription: '登録された打刻場所の範囲内でのみ打刻できるようにします。オフの場合は範囲外でも打刻でき、履歴に記録されます。有効時に範囲外や位置情報が取得できない場合は打刻できません。打刻場所が1件も登録されていない社員には制限が適用されません。在宅勤務や直行直帰がある場合は、あらかじめ場所を登録してください。',
  restrictNeedsLocation: '「打刻時の位置情報記録」を有効にすると設定できます。',
  // 打刻できる場所
  title: '打刻場所の登録',
  // 対象は3つ（全員／指定したプロジェクトの社員／指定した社員のみ）。前の文は、プロジェクトが
  // 入る前の2つ（全員・特定の社員）しか挙げていなかった。決めてもらった文（DF-1。2026-10-09）。
  description: '全員が使える場所、指定したプロジェクトの社員が使える場所、指定した社員のみが使える場所をいくつでも登録できます。登録した場所の範囲内で打刻すると、履歴にその場所の名前が表示されます。',
  empty: '登録されている打刻場所はありません。',
  columnName: '場所の名前',
  columnTarget: '利用できる社員',
  columnAddress: '住所',
  columnRadius: '対象エリア（半径）',
  targetEveryone: '全員',
  targetPerson: '指定した社員のみ',
  targetProject: '指定したプロジェクトの社員',
  targetProjectPlaceholder: 'プロジェクトを選択してください',
  targetProjectNamed: 'プロジェクト：{名前}',
  targetPersonPlaceholder: '社員を選択してください',
  add: '打刻場所を追加',
  searchByAddress: '住所から位置を設定',
  useCurrentLocation: '現在地を設定',
  save: '保存する',
  remove: '削除',
  edit: '編集',
  cancel: 'キャンセル',
  removeConfirm: '「{name}」を削除してもよろしいですか？削除しても過去の打刻履歴には影響しません。',
  addressPlaceholder: '例：東京都千代田区大手町1-1-1',
  addressNotFound: '該当する住所が見つかりませんでした。都道府県や市区町村から入力し直してください。',
  positionLabel: '位置の設定',
  positionNotChosen: '「住所から位置を設定」または「現在地を設定」ボタンで位置を指定してください。',
  radiusLabel: '許容範囲',
  radiusHint: '50m〜5000mの範囲で設定してください。端末による位置誤差を考慮し、少し広めの設定（迷った場合は300m程度）をおすすめします。',
  currentLocationFailed: '現在地を取得できませんでした。ブラウザの位置情報利用を許可して再度お試しください。',
  loadFailed: '通信エラーが発生しました。時間を置いて再度お試しください。',
  // ユーザー編集画面の欄（その社員が打刻できる場所）
  userTitle: '打刻できる場所',
  userDescription: 'この社員が打刻できる場所の一覧です。場所の追加や変更は、自社設定の「勤怠計算・打刻」にある「打刻場所の登録」で行ってください。',
  userColumnKind: '対象区分',
  userKindPersonal: '個別指定',
  userEmpty: '打刻できる場所が登録されていません',
  exemptName: '指定エリア外の打刻制限から除外する',
  exemptDescription: '有効にすると、会社全体の制限が有効な場合でも、この社員は登録場所の外で打刻できます。打刻した場所は記録され、指定エリア外であったことも履歴に残ります。',
  exemptNotActive: '※現在、会社全体のエリア外打刻制限が無効なため、この設定は会社全体の制限が有効になった際に適用されます。',
  exemptSaved: '設定を保存しました',
  // プロジェクト詳細画面の欄
  projectTitle: '所属メンバーが使える打刻場所',
  projectDescription: 'このプロジェクトの所属メンバーが利用できる打刻場所の一覧です。場所の追加や変更は自社設定の「打刻場所の登録」で行ってください。',
  projectEmpty: 'このプロジェクトに割り当てられた打刻場所はありません',
  // 打刻履歴
  outOfRange: '範囲外',
  outOfRangeWithDistance: '範囲外（最寄りまで {n}）',
  // ダッシュボード
  dashboardRestricted: '登録されたエリア外では打刻できません。',
  // 自社設定の一覧
  listItemName: '指定エリア外の打刻制限'
})
